import React from "react";
import { motion } from "framer-motion";
import HeroSection from "./Sections/HeroSection";
import Navbar from "./Sections/Navbar";

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.8,
};

const LandingPage = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <Navbar />
      <HeroSection />
    </motion.div>
  );
};

export default LandingPage;
